<template>
    <div>
        <div class="shelfList" v-for="(shelf,index) in shelfList" :key="shelf.shelfId">
            <div>
                <h2>{{shelf.shelfName}}</h2>
                <span class="discolor" @click="$router.push(shelfRouter[shelf.shelfId] || '/mall')">查看更多 ></span>
            </div>
            <ul :class="'product'+index">
                <li v-for="product in shelf.productList" :key="product.productId" @click="clickProduct(product.productId, product.productType)">
                    <div class="productName">
                        <h3>{{product.productName}}</h3>
                        <h4 v-if="product.productType == 'rent' ">¥{{product.displayUnitRental}}/天起</h4>
                        <h4 v-else>¥{{product.benchmarkPrice}}/片</h4>
                    </div>
                    <div>
                        <img :src="product.faceImagePath" :alt="product.productName"/>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";
import { productDetailPageMap } from '@/libs/constant/product.js';

export default {
    data() {
        return {
            shelfList: [],
            shelfRouter: {
                pallet_bank: '/pallet-bank',
                shelf_discount: '/mall',
                shelf_hot: '/mall',
                shelf_rent: '/lease'
            },
        }
    },
    mounted() {
        this.queryHomeDisplayShelf();
    },
    computed: {
        ...mapState('mall', ['queryParams'])
    },
    methods: {
        queryHomeDisplayShelf() {
            let data = {
                url: 'http://MID-CLIENT-MALL/messageService/shelfService/queryShelfList4HomeDisplay',
            }
            this.invoke(data).then(rs => {
                this.shelfList = rs;
            })
        },
        clickProduct(productId, productType) {

            let routeData = this.$router.resolve({
                path: productDetailPageMap[productType],
                query: { productId }
            });

            window.open(routeData.href, '_blank');
        },
        checkMore(shelfId) {
            this.$router.push({
                path: '/mall',
            });
            this.$store.commit('mall/setShelfList', [shelfId]);
        }
    }
}
</script>

<style lang="less" scoped>
.shelfList {
    height: 260px;
    > div {
        margin: 20px 0 20px 0;
        h2 {
            display: inline;
            padding-right: 20px;
        }
    }
    .product0{
        li:first-child{
            background: url("~assets/image/index-img/orange.png") no-repeat;
        }
    }
     .product1{
        li:first-child{
            background: url("~assets/image/index-img/green.png") no-repeat;
        }
    }
    .product2{
        li:first-child{
            background: url("~assets/image/index-img/blue.png") no-repeat;
        }
    }
    .product3{
        li:first-child{
            background: url("~assets/image/index-img/orange.png") no-repeat;
        }
    }
    ul {
        height: 260px;
        li:first-child {
            width: 325px;
            height: 205px;
            color: #fff;
            text-align: left;
            border-radius: 8px 12px 22px 15px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 5px;
            transition: all 0.2s;
            .productName {
                margin: 15px 0 0 15px;
                h4{
                    font-size: 20px;
                }
            }
            div:nth-child(2) {
                margin: -25px 0 0 109px;
                width:180px;
                // height: 150px;
                img{
                    width: 180px;
                }
            }
            &:hover {
                opacity: 0.8;
                color: #fff;
            }
        }
        li {
            float: left;
            width: 170px;
            height: 200px;
            // background: #f6f5f5;
            background: url("~assets/image/index-img/gray.png") no-repeat;
            border-radius: 10px;
            cursor: pointer;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 17px;
            transition: all 0.3s;
            transition-delay: 0.1s;
            &:hover {
                opacity: 0.8;
                color: #ff9000;
            }
            div:first-child {
                h3 {
                    margin: 15px 0 5px 0;
                }
            }
            div:last-child {
                margin-top: 10px;
                width: 150px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                    width: 150px;
                    margin-top:-30px
                    // height: 93px;
                }
            }
        }
        
    }
}
</style>